import React from 'react'
import Honeybadger from 'honeybadger-js'

import GenericError from 'components/atoms/GenericError'

const withErrorBoundary = WrappedComponent => {
  return class extends React.Component {
    constructor(props) {
      super(props)
      this.state = { error: null }
    }

    componentDidCatch(error, errorInfo) {
      this.setState({
        error: error
      })
      Honeybadger.notify(error, {
        name: 'WithErrorBoundary',
        context: { errorInfo }
      })
    }

    render() {
      if (this.state.error) {
        return <GenericError />
      }

      return <WrappedComponent {...this.props} />
    }
  }
}

export default withErrorBoundary
